import { useMutation } from '@tanstack/react-query'
import { createSubAdmins } from '../index'

const useCreateSubAdmins = () =>
  useMutation({
    mutationFn: createSubAdmins,
  })

export default useCreateSubAdmins
